import type { Preset } from "@primeuix/themes/types";
import base from "./base";
import accordion from "./accordion";
import autocomplete from "./autocomplete";
import avatar from "./avatar";
import badge from "./badge";
import blockui from "./blockui";
import breadcrumb from "./breadcrumb";
import button from "./button";
import card from "./card";
import carousel from "./carousel";
import cascadeselect from "./cascadeselect";
import checkbox from "./checkbox";
import chip from "./chip";
import colorpicker from "./colorpicker";
import confirmdialog from "./confirmdialog";
import confirmpopup from "./confirmpopup";
import contextmenu from "./contextmenu";
import datatable from "./datatable";
import dataview from "./dataview";
import datepicker from "./datepicker";
import dialog from "./dialog";
import divider from "./divider";
import dock from "./dock";
import drawer from "./drawer";
import editor from "./editor";
import fieldset from "./fieldset";
import fileupload from "./fileupload";
import floatlabel from "./floatlabel";
import galleria from "./galleria";
import iconfield from "./iconfield";
import iftalabel from "./iftalabel";
import image from "./image";
import imagecompare from "./imagecompare";
import inlinemessage from "./inlinemessage";
import inplace from "./inplace";
import inputchips from "./inputchips";
import inputgroup from "./inputgroup";
import inputnumber from "./inputnumber";
import inputotp from "./inputotp";
import inputtext from "./inputtext";
import knob from "./knob";
import listbox from "./listbox";
import megamenu from "./megamenu";
import menu from "./menu";
import menubar from "./menubar";
import message from "./message";
import metergroup from "./metergroup";
import multiselect from "./multiselect";
import orderlist from "./orderlist";
import organizationchart from "./organizationchart";
import overlaybadge from "./overlaybadge";
import paginator from "./paginator";
import panel from "./panel";
import panelmenu from "./panelmenu";
import password from "./password";
import picklist from "./picklist";
import popover from "./popover";
import progressbar from "./progressbar";
import progressspinner from "./progressspinner";
import radiobutton from "./radiobutton";
import rating from "./rating";
import ripple from "./ripple";
import scrollpanel from "./scrollpanel";
import select from "./select";
import selectbutton from "./selectbutton";
import skeleton from "./skeleton";
import slider from "./slider";
import speeddial from "./speeddial";
import splitbutton from "./splitbutton";
import splitter from "./splitter";
import stepper from "./stepper";
import steps from "./steps";
import tabmenu from "./tabmenu";
import tabs from "./tabs";
import tabview from "./tabview";
import tag from "./tag";
import terminal from "./terminal";
import textarea from "./textarea";
import tieredmenu from "./tieredmenu";
import timeline from "./timeline";
import toast from "./toast";
import togglebutton from "./togglebutton";
import toggleswitch from "./toggleswitch";
import toolbar from "./toolbar";
import tooltip from "./tooltip";
import tree from "./tree";
import treeselect from "./treeselect";
import treetable from "./treetable";
import virtualscroller from "./virtualscroller";
import extend from "./extend";

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        datatable,
        dataview,
        datepicker,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        floatlabel,
        galleria,
        iconfield,
        iftalabel,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        paginator,
        panel,
        panelmenu,
        password,
        picklist,
        popover,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        ripple,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitbutton,
        splitter,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        tag,
        terminal,
        textarea,
        tieredmenu,
        timeline,
        toast,
        togglebutton,
        toggleswitch,
        toolbar,
        tooltip,
        tree,
        treeselect,
        treetable,
        virtualscroller
    },
    extend
} satisfies Preset